/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Locality_CreateInputs */

const cs_requirements_locality_create = /** @type {(inputs: Requirements_Locality_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat lokalitu`)
};

const en_requirements_locality_create = /** @type {(inputs: Requirements_Locality_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add locality`)
};

/**
* | output |
* | --- |
* | "Add locality" |
*
* @param {Requirements_Locality_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality_create = /** @type {((inputs?: Requirements_Locality_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Locality_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality_create(inputs)
	return cs_requirements_locality_create(inputs)
});